// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"4b8a199b","644":"007e9f96"}[chunkId] + ".chunk.css";
};